import { Employee, Expertise, Resource } from 'models';

export function getId(value: Expertise | Resource | Employee): string {
    return value.id.toString();
}
